import { FC } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { store } from "store/store";
import { ThemeProvider } from "styled-components";

import { GlobalModal } from "components/GlobalModal";
import ResponsiveAlert from "components/ResponsiveAlert";
import { ValidationModal } from "components/ValidationModal";

import createdBrowserRouter from "./routes/router";
import GlobalStyles from "./styles/styled";
import { theme } from "./styles/theme";

const ReduxProviderChildrenWrapper: FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <ResponsiveAlert />
      <GlobalStyles />
      <RouterProvider router={createdBrowserRouter} />
      <GlobalModal />
      <ValidationModal />
    </ThemeProvider>
  );
};

function App() {
  return (
    <ReduxProvider store={store}>
      <ReduxProviderChildrenWrapper />
    </ReduxProvider>
  );
}

export default App;
